<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { defineEmits, reactive, ref } from 'vue';

import CardComponent from '@/components/ui/CardComponent.vue';

import type { ResolveReferralRewardRequest } from '@/types/services/referralReward/referralReward.type.ts';

const { t } = useI18n();
const emits = defineEmits(['closeModal']);

defineProps<{
  // True for a REVIEW reward: money may have moved on Aplo, the admin must check first.
  showReviewWarning: boolean;
}>();

const formValid = ref<boolean>(false);

const form = reactive<ResolveReferralRewardRequest>({ note: '' });

const noteRules = [
  (value: string) => {
    const length = (value ?? '').trim().length
    return (length >= 5 && length <= 1000) || t('components.resolveReferralReward.noteLength')
  }
];

function submit(): void {
  emits('closeModal', { note: form.note.trim() })
}
</script>

<template>
  <v-form class="w-100 d-flex align-center">
    <CardComponent with-actions>
      <template #title>
        {{ t('components.resolveReferralReward.title') }}
      </template>
      <template #item>
        <v-alert
          v-if="showReviewWarning"
          class="mb-4"
          color="warning"
          variant="outlined"
        >
          {{ t('components.resolveReferralReward.reviewWarning') }}
        </v-alert>
        <p class="mb-4">{{ t('components.resolveReferralReward.message') }}</p>
        <v-form v-model="formValid">
          <v-textarea
            v-model="form.note"
            :label="t('components.resolveReferralReward.note')"
            :rules="noteRules"
            counter="1000"
            hide-details="auto"
            rows="4"
          />
        </v-form>
      </template>
      <template #actions>
        <div class="d-flex flex-row justify-space-between ga-4 mt-2">
          <v-btn variant="outlined" @click.prevent="emits('closeModal', false)">
            {{ t('common.buttons.cancel') }}
          </v-btn>
          <v-btn
            :disabled="!formValid"
            color="primary"
            type="submit"
            variant="flat"
            @click.prevent="submit"
          >
            {{ t('common.buttons.validate') }}
          </v-btn>
        </div>
      </template>
    </CardComponent>
  </v-form>
</template>
